import type { IconButtonProps } from '@mui/material';
import { IconButton } from '@mui/material';
import type { FixedProductInput } from '@vy/types';
import { withDefault } from '@vy/utils';
import { useFormContext } from 'react-hook-form';
import { CloseIcon } from '../../../../../../components/icons';
import type { NewPlanForm } from '../../CreatePlanForm/create-plan-form-types/new-plan-form';
import type { PlanInputForm } from '../../CreatePlanForm/create-plan-form-types/plan-input-form';

type RemovePromotionRowProps = {
  promotion: FixedProductInput;
} & IconButtonProps;

export const RemovePromotionRow: React.FC<RemovePromotionRowProps> = ({ promotion, ...props }) => {
  const { setValue, getValues } = useFormContext<PlanInputForm, NewPlanForm>();

  const handleRemoveRow = () => {
    const promotions = getValues('promotionProducts');
    const updatePromotions = withDefault(promotions, []).filter(
      (iterablePromotion) => iterablePromotion.id !== promotion.id,
    );
    setValue('promotionProducts', updatePromotions);
  };

  return (
    <IconButton className="h-6 w-6" onClick={handleRemoveRow} {...props}>
      <CloseIcon />
    </IconButton>
  );
};
